
import React, { useState } from 'react';
import { Button } from '../../../components/base/Button';

export const NewsletterSection: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsSubmitting(true);
    
    try {
      const formData = new FormData();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d3l24ja96ie05rb9m57g', {
        method: 'POST',
        body: new URLSearchParams(formData as any),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (response.ok) {
        setIsSubmitted(true);
        setEmail('');
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 bg-emerald-50">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Subscribe to our monthly newsletter to get destination updates
        </h2>
        <p className="text-lg text-gray-600 mb-8">
          Stay updated with the latest travel destinations, tips, and exclusive offers
        </p>
        
        {isSubmitted ? (
          <div className="bg-emerald-100 border border-emerald-400 text-emerald-700 px-6 py-4 rounded-lg">
            <i className="ri-check-line w-6 h-6 flex items-center justify-center mx-auto mb-2"></i>
            <p className="font-medium">Thanks for subscribing!</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" data-readdy-form id="newsletter-form">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="e.g., email@example.com"
              required
              maxLength={250}
              className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none text-sm"
            />
            <Button 
              type="submit" 
              disabled={isSubmitting}
              className="sm:w-auto"
            >
              {isSubmitting ? 'Joining...' : 'Join'}
            </Button>
          </form>
        )}
      </div>
    </section>
  );
};
